/*
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2021-11-18 19:35:59
 * @LastEditors: sueRimn
 * @LastEditTime: 2022-03-01 14:03:42
 */
import Vue from 'vue'
import App from './App.vue'
// elementui 引入使用 国际化
import i18n from '@/i18n/index'
// element引入
import Element from 'element-ui'
import '@/assets/style/element-vue.scss'

/* 输入框禁止输入指定特殊字符，不能输入空格 */
Vue.prototype.validForbid = function (value) {
  value = value.replace(/[`~!@#$%^*()\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……*（）——\-+={}|《》？：“”【】、；‘'，。、]/g, '').replace(/\s/g, "");
  return value;
}
Vue.use(Element, {
  i18n: (key, value) => i18n.t(key, value)
})

/* 允许输入空格，但不允许其他特殊字符 */
Vue.prototype.allowSpace = function (value) {
  value = value.replace(/[`~!@#$%^*+=<>?"{}|\'\\[\]·~！@#￥%……*（）——+={}|《》？：“”【】、；‘'，。、]/g, '');
  return value;
}
/* 允许输入特定字符（'/', '(', ')',）中英文均可，适用于详细地址 */
Vue.prototype.addressValidForbid = function (value) {
  value = value.replace(/[`~!@#$%^*+=<>?"{}|\'\\[\]·~！@#￥%……*——+={}|《》？：“”【】、；‘'，。、]/g, '');
  return value;
}

/* 允许输入特定字符（'/', '(', ')',）中英文均可，适用于详细地址 */
// Vue.prototype.addressValidForbid = function (value) {
//   value = value.replace(/[`~!@#$%^*\-+=<>?:"{}|,.\;'\\[\]·~！@#￥%……*——\-+={}|《》？：“”【】、；‘'，。、]/g, '');
//   return value;
// }
Vue.use(Element, {
  i18n: (key, value) => i18n.t(key, value)
})
// 引入矢量图标
import "./assets/iconfont/iconfont.css"
import router from './router'
import store from './store'

// 驿站 国际化内部实现
import { lang } from '@public/utils/utils.js'
Vue.prototype.$lang = lang
// Avue组件库
import Avue from './components/avuex/index'
import('./components/avuex/styles/index.scss')

Vue.use(Avue);
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')
